import React, { useContext, useEffect, useState } from "react";
import ModalAdicion from "./ModalAdicion/ModalAdicion";
import AppContext from "../../../Context/AppContext";
import { infoSource } from "../../../util/util";
import "./NuevosDomicilios.css";

const OtrosDomicilios = ({ acreditadoInfo }) => {
  const [showModal, setShowModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const [direcciones, setDirecciones] = useState([]);
  const { checkUserSession, changeLoading } = useContext(AppContext);
  const infoUs = checkUserSession();

  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    changeLoading(true);
    const dirList = await infoSource.Acreditados.GetNuevosDomicilios(
      infoUs,
      acreditadoInfo.AcreditadoId
    );
    setDirecciones(dirList);
    changeLoading(false);
  }
  function Editar(item) {
    setCurrentRow(item);
    setShowModal(true);
  }
  return (
    <div className="NuevosDomicilios__container">
      <button
        className="btnNuevaGestion"
        onClick={() => {
          setCurrentRow({ Id: 0 });
          setShowModal(true);
        }}
      >
        Registrar nuevo domicilio
      </button>
      <div className="NuevosDomicilios__Itemcontainer">
        {direcciones.map((item, i) => (
          <div
            key={`NuevosDomicilios__Item${i}`}
            className="NuevosDomicilios__Item"
          >
            <h1>
              Nombre: <span>{item.Nombre}</span>
            </h1>
            <h1>
              Nvos. Domicilios Y Tels.: <span>{item.Direccion}</span>
            </h1>
            <h1>
              Télefono: <span>{item.Telefono}</span>
            </h1>
            <h1>
              Parentesco: <span>{item.Propietario}</span>
            </h1>
            <button onClick={() => Editar(item)}> Editar</button>
          </div>
        ))}
      </div>
      <ModalAdicion
        setShow={setShowModal}
        show={showModal}
        setCurrentRow={setCurrentRow}
        currentRow={currentRow}
        acreditadoInfo={acreditadoInfo}
        loadInfo={loadInfo}
      />
    </div>
  );
};

export default OtrosDomicilios;
